import { render, staticRenderFns } from "./xiangqing.vue?vue&type=template&id=4af6daca&scoped=true"
import script from "./xiangqing.vue?vue&type=script&lang=js"
export * from "./xiangqing.vue?vue&type=script&lang=js"
import style0 from "./xiangqing.vue?vue&type=style&index=0&id=4af6daca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af6daca",
  null
  
)

export default component.exports